// App.js
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Register from './components/register';
import Login from './components/login';
import RecoverPassword from './components/RecoverPassword';
import ResetPassword from './components/ResetPassword';

import Alumnos from './components/Alumnos';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Dashboard from './layout/dashboard';
import Chat from './layout/chat';
import Report from './layout/report';
import VectorStoreExplorer from './components/VectorStoreExplorer';
import HealthCheck from "./components/HealthCheck";
import { ChatProvider } from './context/ChatContext';
import Cursos from './components/Cursos';
import Admin from './components/Admin'; // 👈 nuevo
import VectorUploader from './components/VectorUploader'; // Vector Store Uploader Front end

import '@fortawesome/fontawesome-free/css/all.min.css';

import { useLocation } from 'react-router-dom';

const PrivateRoute = ({ element }) => {
  const { auth } = useContext(AuthContext);
  const location = useLocation();

  return auth
    ? element
    : <Navigate to="/login" state={{ from: location }} replace />;
};

const PublicRoute = ({ element }) => element;

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
        <Router>
          <Routes>
            {/* Públicas */}
            <Route path="/login" element={<PublicRoute element={<Login />} />} />
            <Route path="/register" element={<PublicRoute element={<Register />} />} />
            <Route path="/recover" element={<PublicRoute element={<RecoverPassword />} />} />
            <Route path="/reset-password" element={<PublicRoute element={<ResetPassword />} />} />

            {/* Páginas existentes (públicas según tu setup actual) */}
            <Route path="/dashboard" element={<PublicRoute element={<Dashboard />} />} />
            <Route path="/chat" element={<PublicRoute element={<Chat />} />} />
            <Route path="/health-check" element={<PublicRoute element={<HealthCheck />} />} />

            {/* Rutas privadas existentes */}
            <Route path="/vector-files" element={<PrivateRoute element={<VectorStoreExplorer />} />} />
            <Route path="/report" element={<PrivateRoute element={<Report />} />} />
            <Route path="/cursos" element={<PublicRoute element={<Cursos />} />} />
            <Route path="/alumnos" element={<PublicRoute element={<Alumnos />} />} />

            {/* NUEVO: área Admin (privada) con layout + rutas anidadas */}
            <Route
              path="/admin"
              element={<PrivateRoute element={<Admin />} />}
            >
              {/* Por defecto, /admin muestra Cursos */}
              <Route index element={<Cursos />} />
              <Route path="cursos" element={<Cursos />} />
              <Route path="alumnos" element={<Alumnos />} />
              <Route path="report" element={<Report />} />
              <Route path="vector-files" element={<VectorStoreExplorer />} /> {/* 👈 */}
              <Route path="vector-uploader" element={<VectorUploader />} /> {/* 👈 NUEVO  vector store uploader*/}
            </Route>

            {/* Wildcard */}
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;
